export default __webpack_public_path__ + "static/media/513.499f84de.png";